import _ from 'lodash';

export const tags = [
  'new',
  'classic',
  'natural',
  'lux',
  'openshelf',
  'minimal',
  'sensitive',
  'local',
  'korea',
  'japan',
];

export const results = [
  {
    name: '嘗鮮衝鋒隊',
    tags: ['#新奇', '#好玩', '#錢錢對不起我需要這個'],
    friend: '神秘探索者',
    title: '「每次嘗試都是探索未知的樂趣！」',
    comments: [
      '你熱愛嘗試最新的美妝產品。你的化妝包就像是一座新品博物館，充滿驚喜。買新品的速度比任何人都要快～',
    ],
    talks: [
      '「你知道〇〇出了新品了嗎！？」',
      '「這個很久了啦，我已經買了～」',
      '「你到底有多少東西啦！！！',
    ],
    losePercent: 99,
    tag: 'new',
    image: '1.png',
    friendImage: '12.png',
  },
  {
    name: '經典愛好者',
    tags: ['#經典不敗', '#無限回購'],
    friend: '極簡主義者',
    title: '「經典就是好用！」',
    comments: [
      '目光總是離不開元老級產品，深信它們就是最好的選擇，不要輕易嘗試新東西～',
    ],
    talks: [
      '「用了10年，最近還是用這牌嗎？」',
      '「這個一定要有的吧～」',
      '「什麼！？你還沒有試過這個！」',
    ],
    losePercent: 45,
    tag: 'classic',
    image: '2.png',
    friendImage: '6.png',
  },
  {
    name: '純淨保養達人',
    tags: ['#植物萃取', '#無動物測試', '#純淨之美'],
    friend: '極簡主義者',
    title: '「保養同時也不要忘記環境喔～」',
    comments: ['你堅持選擇純淨護膚產品，關注成分的來源，保養同時愛護環境。'],
    talks: [
      '「純淨就是美～」',
      '「就是要無毒才能安心呀！」',
      '「你知道XXX是零殘忍的品牌嗎！」',
    ],
    losePercent: 60,
    tag: 'natural',
    image: '3.png',
    friendImage: '6.png',
  },
  {
    name: '奢華追求者',
    tags: ['#高尚', '#專櫃常客', '#自我犒賞'],
    friend: '嘗鮮衝鋒隊',
    title: '「每一刻都值得奢華對待～」',
    comments: [
      '你熱愛高端護膚品，享受每一次的奢華體驗，讓自己在護膚中感受尊貴。',
    ],
    talks: [
      '「一起去看看最新的一季吧！」',
      '「這個明星色超美的啦～」',
      '「便宜沒好貨～專櫃就是特別好用！」',
    ],
    losePercent: 90,
    tag: 'lux',
    image: '4.png',
    friendImage: '1.png',
  },
  {
    name: 'CP挖寶專家',
    tags: ['#開架超好買', '#性價比', '#優惠'],
    friend: '嘗鮮衝鋒隊',
    title: '「每次挖寶都是一次驚喜之旅！」',
    comments: ['你擅長發掘開架產品中的寶藏，時刻留意優惠，讓美麗更具性價比。'],
    talks: [
      '「這個超好用的啦！要囤！」',
      '「今天屈XX、萬O有優惠喔！要去逛逛嗎？」',
      '「買滿OO送XX，要一齊嗎？」',
    ],
    losePercent: 50,
    tag: 'openshelf',
    image: '5.png',
    friendImage: '1.png',
  },
  {
    name: '極簡主義者',
    tags: ['#重點成份', '#成份表分析師', '#簡約'],
    friend: '經典愛好者',
    title: '「越簡單，越美麗。」',
    comments: [
      '你喜歡成分簡單的護膚品，堅持少即是多的護理理念，讓肌膚自由呼吸。',
    ],
    talks: [
      '「這個成份表過關～」',
      '「有細紋的話可以試試XXX這個成份喔！（建議）」',
      '「配方太複雜就會刺激皮膚！」',
    ],
    losePercent: 20,
    tag: 'minimal',
    image: '6.png',
    friendImage: '2.png',
  },
  {
    name: '敏感肌守護者',
    tags: ['#面紅紅', '#安全第一'],
    friend: '極簡主義者',
    title: '「呵護敏感肌，從選擇開始。」',
    comments: ['你專注於選擇專為敏感肌設計的產品，時刻關注肌膚的安全與舒適。'],
    talks: ['「XX牌就是適合我這種敏感肌～」', '「（看到包裝上的乾敏肌」買！」'],
    losePercent: 50,
    tag: 'sensitive',
    image: '7.png',
    friendImage: '6.png',
  },
  {
    name: '本地薑',
    tags: ['#支持本地品牌', '#香港製造'],
    friend: '敏感肌守護者',
    title: '「要買就買香港品牌！」',
    comments: ['你喜歡發掘在地的護膚產品，熱衷於支持香港本地護膚品牌～'],
    talks: [
      '「只有本地品牌才能了解當地的氣候呀！」',
      '「不如你先試試再說吧～」',
      '「香港製造的護膚品也能婫美大品牌呢！」',
    ],
    losePercent: 60,
    tag: 'local',
    image: '8.png',
    friendImage: '7.png',
  },
  {
    name: '哈韓一族',
    tags: ['#明星同款', '#沉迷代購', '#潮流美妝'],
    friend: '嘗鮮衝鋒隊',
    title: '「韓國美妝，潮流的代名詞。」',
    comments: [
      '你沉迷於韓國護膚品，喜歡追隨偶像的護膚秘訣，讓自己每一天都充滿時尚感。',
    ],
    talks: [
      '「你知道嗎？元英也在用這個！！」',
      '「這個是XX代言的不能不買吧～」',
      '「我要跟OO用一樣的！」',
    ],
    losePercent: 55,
    tag: 'korea',
    image: '9.png',
    friendImage: '1.png',
  },
  {
    name: '哈日一族',
    tags: ['#日本文化', '#追星'],
    friend: '哈韓一族',
    title: '「沉浸在日本文化的魅力中！」',
    comments: [
      '你熱愛日本製的護膚和化妝品，從日劇到動漫，無不影響著你的生活品味，總是追求最新的日系潮流～',
    ],
    talks: [
      '「這期XXX雜誌介紹的超燒！」',
      '「XXX和OOO雜誌的第一名就是要買呀～～」',
      '「日本女生都在用什麼呀？皮膚超好的！」',
    ],
    losePercent: 55,
    tag: 'japan',
    image: '10.png',
    friendImage: '9.png',
  },
  {
    name: '混搭大師',
    tags: ['#混搭', '#嘗試', '#自由選擇'],
    friend: 'CP挖寶專家',
    title: '「多樣化的選擇，隨心所欲的護膚。」',
    comments: [
      '你喜歡嘗試不同品牌和產品，對於品牌或類型沒有固定的偏好，享受護膚的多元性～',
    ],
    talks: ['「原論是專櫃或是開架，好用就是真理！」', '「什麼都試試看吧～」'],
    losePercent: 70,
    tag: '',
    image: '11.png',
    friendImage: '5.png',
  },
  {
    name: '神秘探索者',
    tags: ['#小眾', '#持續探索'],
    friend: '極簡主義者',
    title: '「少而精，才是探索的真諦。」',
    comments: [
      '你對護膚品的選擇非常謹慎，喜歡用少量但獨特的產品，讓護膚變得神秘又有趣。',
    ],
    talks: ['「你都用在用什麼？？」', '「我只用XX跟OO就夠了！！」'],
    losePercent: 30,
    tag: '',
    image: '12.png',
    friendImage: '6.png',
  },
];

export const ranks = [
  {
    name: '保濕',
    key: 'hydration',
    factor: {
      overall: [
        {
          productId: 2585,
          productName: '低分子玻尿酸精華',
          brandName: 'Torriden',
          rank: 1,
        },
        {
          productId: 204,
          productName: '特效保濕面霜',
          brandName: "Kiehl's",
          rank: 2,
        },
        {
          productId: 170,
          productName: '深層高效保濕面霜',
          brandName: 'Curel',
          rank: 3,
        },
        {
          productId: 615,
          productName: 'B5萬用修復霜',
          brandName: 'La Roche-Posay',
          rank: 4,
        },
        {
          productId: 205,
          productName: '精華面霜',
          brandName: 'La Mer',
          rank: 5,
        },
        {
          productId: 165,
          productName: '長效滋潤修復霜',
          brandName: 'CeraVe',
          rank: 6,
        },
        {
          productId: 575,
          productName: 'HYA3 補濕修護精華',
          brandName: 'factiv',
          rank: 7,
        },
        {
          productId: 407,
          productName: '肌研極潤保濕化妝水(清爽型)',
          brandName: 'Hada Labo 肌研',
          rank: 8,
        },
        {
          productId: 182,
          productName: '強效保濕皇牌燕麥面霜',
          brandName: 'First Aid Beauty',
          rank: 9,
        },
        {
          productId: 564,
          productName: '賦活雙精華',
          brandName: 'Clarins',
          rank: 10,
        },
      ],
      neutral: [
        {
          productId: 204,
          productName: '特效保濕面霜',
          brandName: "Kiehl's",
          rank: 1,
        },
        {
          productId: 2585,
          productName: '低分子玻尿酸精華',
          brandName: 'Torriden',
          rank: 2,
        },
        {
          productId: 575,
          productName: 'HYA3 補濕修護精華',
          brandName: 'factiv',
          rank: 3,
        },
        {
          productId: 205,
          productName: '精華面霜',
          brandName: 'La Mer',
          rank: 4,
        },
        {
          productId: 615,
          productName: 'B5萬用修復霜',
          brandName: 'La Roche-Posay',
          rank: 5,
        },
        {
          productId: 165,
          productName: '長效滋潤修復霜',
          brandName: 'CeraVe',
          rank: 6,
        },
        {
          productId: 407,
          productName: '肌研極潤保濕化妝水(清爽型)',
          brandName: 'Hada Labo 肌研',
          rank: 7,
        },
        {
          productId: 182,
          productName: '強效保濕皇牌燕麥面霜',
          brandName: 'First Aid Beauty',
          rank: 8,
        },
        {
          productId: 170,
          productName: '深層高效保濕面霜',
          brandName: 'Curel',
          rank: 9,
        },
        {
          productId: 564,
          productName: '賦活雙精華',
          brandName: 'Clarins',
          rank: 10,
        },
      ],
      dry: [
        {
          productId: 2585,
          productName: '低分子玻尿酸精華',
          brandName: 'Torriden',
          rank: 1,
        },
        {
          productId: 165,
          productName: '長效滋潤修復霜',
          brandName: 'CeraVe',
          rank: 2,
        },
        {
          productId: 204,
          productName: '特效保濕面霜',
          brandName: "Kiehl's",
          rank: 3,
        },
        {
          productId: 205,
          productName: '精華面霜',
          brandName: 'La Mer',
          rank: 4,
        },
        {
          productId: 615,
          productName: 'B5萬用修復霜',
          brandName: 'La Roche-Posay',
          rank: 5,
        },
        {
          productId: 170,
          productName: '深層高效保濕面霜',
          brandName: 'Curel',
          rank: 6,
        },
        {
          productId: 449,
          productName: '敏感肌化妝水',
          brandName: 'Muji',
          rank: 7,
        },
        {
          productId: 190,
          productName: '肌研極潤保濕冰感霜',
          brandName: 'Hada Labo 肌研',
          rank: 8,
        },
        {
          productId: 182,
          productName: '強效保濕皇牌燕麥面霜',
          brandName: 'First Aid Beauty',
          rank: 9,
        },
        {
          productId: 407,
          productName: '肌研極潤保濕化妝水(清爽型)',
          brandName: 'Hada Labo 肌研',
          rank: 10,
        },
      ],
      oily: [
        {
          productId: 2585,
          productName: '低分子玻尿酸精華',
          brandName: 'Torriden',
          rank: 1,
        },
        {
          productId: 170,
          productName: '深層高效保濕面霜',
          brandName: 'Curel',
          rank: 2,
        },
        {
          productId: 204,
          productName: '特效保濕面霜',
          brandName: "Kiehl's",
          rank: 3,
        },
        {
          productId: 205,
          productName: '精華面霜',
          brandName: 'La Mer',
          rank: 4,
        },
        {
          productId: 165,
          productName: '長效滋潤修復霜',
          brandName: 'CeraVe',
          rank: 5,
        },
        {
          productId: 575,
          productName: 'HYA3 補濕修護精華',
          brandName: 'factiv',
          rank: 6,
        },
        {
          productId: 407,
          productName: '肌研極潤保濕化妝水(清爽型)',
          brandName: 'Hada Labo 肌研',
          rank: 7,
        },
        {
          productId: 182,
          productName: '強效保濕皇牌燕麥面霜',
          brandName: 'First Aid Beauty',
          rank: 8,
        },
        {
          productId: 615,
          productName: 'B5萬用修復霜',
          brandName: 'La Roche-Posay',
          rank: 9,
        },
        {
          productId: 449,
          productName: '敏感肌化妝水',
          brandName: 'Muji',
          rank: 10,
        },
      ],
      combination: [
        {
          productId: 2585,
          productName: '低分子玻尿酸精華',
          brandName: 'Torriden',
          rank: 1,
        },
        {
          productId: 204,
          productName: '特效保濕面霜',
          brandName: "Kiehl's",
          rank: 2,
        },
        {
          productId: 170,
          productName: '深層高效保濕面霜',
          brandName: 'Curel',
          rank: 3,
        },
        {
          productId: 615,
          productName: 'B5萬用修復霜',
          brandName: 'La Roche-Posay',
          rank: 4,
        },
        {
          productId: 165,
          productName: '長效滋潤修復霜',
          brandName: 'CeraVe',
          rank: 5,
        },
        {
          productId: 205,
          productName: '精華面霜',
          brandName: 'La Mer',
          rank: 6,
        },
        {
          productId: 407,
          productName: '肌研極潤保濕化妝水(清爽型)',
          brandName: 'Hada Labo 肌研',
          rank: 7,
        },
        {
          productId: 575,
          productName: 'HYA3 補濕修護精華',
          brandName: 'factiv',
          rank: 8,
        },
        {
          productId: 564,
          productName: '賦活雙精華',
          brandName: 'Clarins',
          rank: 9,
        },
        {
          productId: 548,
          productName: '積雪草修復面膜',
          brandName: 'Vecs Gardenia 嘉丹妮爾',
          rank: 10,
        },
      ],
      sensitive: [
        {
          productId: 2585,
          productName: '低分子玻尿酸精華',
          brandName: 'Torriden',
          rank: 1,
        },
        {
          productId: 170,
          productName: '深層高效保濕面霜',
          brandName: 'Curel',
          rank: 2,
        },
        {
          productId: 204,
          productName: '特效保濕面霜',
          brandName: "Kiehl's",
          rank: 3,
        },
        {
          productId: 205,
          productName: '精華面霜',
          brandName: 'La Mer',
          rank: 4,
        },
        {
          productId: 165,
          productName: '長效滋潤修復霜',
          brandName: 'CeraVe',
          rank: 5,
        },
        {
          productId: 615,
          productName: 'B5萬用修復霜',
          brandName: 'La Roche-Posay',
          rank: 6,
        },
        {
          productId: 564,
          productName: '賦活雙精華',
          brandName: 'Clarins',
          rank: 7,
        },
        {
          productId: 548,
          productName: '積雪草修復面膜',
          brandName: 'Vecs Gardenia 嘉丹妮爾',
          rank: 8,
        },
        {
          productId: 182,
          productName: '強效保濕皇牌燕麥面霜',
          brandName: 'First Aid Beauty',
          rank: 9,
        },
        {
          productId: 407,
          productName: '肌研極潤保濕化妝水(清爽型)',
          brandName: 'Hada Labo 肌研',
          rank: 10,
        },
      ],
    },
  },
  {
    name: '毛孔',
    key: 'porecare',
    factor: {
      overall: [
        {
          productId: 464,
          productName: '護膚精華露 （神仙水）',
          brandName: 'SK-ll',
          rank: 1,
        },
        {
          productId: 3326,
          productName: 'VT 塗抹式微針精華 100',
          brandName: 'VT Cosmetics',
          rank: 2,
        },
        {
          productId: 623,
          productName: 'Soft Pads',
          brandName: 'Stridex',
          rank: 3,
        },
        {
          productId: 2588,
          productName: '天然溫和清黑頭粉刺鼻頭貼',
          brandName: 'Ilso',
          rank: 4,
        },
        {
          productId: 2795,
          productName: '夜間修復精華',
          brandName: 'YSL',
          rank: 5,
        },
        {
          productId: 426,
          productName: 'PHA2 軟化角質爽膚水',
          brandName: 'factiv',
          rank: 6,
        },
        {
          productId: 34878,
          productName: '綠蕃茄瞬效緊緻毛孔精華',
          brandName: 'SUNGBOON EDITOR',
          rank: 7,
        },
        {
          productId: 82,
          productName: 'Obagi C10 維他命精華營養液',
          brandName: 'Dermacept',
          rank: 8,
        },
        {
          productId: 435,
          productName: '流金水',
          brandName: 'IPSA',
          rank: 9,
        },
        {
          productId: 627,
          productName: '去印收毛孔精華',
          brandName: 'The Ordinary',
          rank: 10,
        },
      ],
      neutral: [
        {
          productId: 3326,
          productName: 'VT 塗抹式微針精華 100',
          brandName: 'VT Cosmetics',
          rank: 1,
        },
        {
          productId: 464,
          productName: '護膚精華露 （神仙水）',
          brandName: 'SK-ll',
          rank: 2,
        },
        {
          productId: 623,
          productName: 'Soft Pads',
          brandName: 'Stridex',
          rank: 3,
        },
        {
          productId: 2795,
          productName: '夜間修復精華',
          brandName: 'YSL',
          rank: 4,
        },
        {
          productId: 627,
          productName: '去印收毛孔精華',
          brandName: 'The Ordinary',
          rank: 5,
        },
        {
          productId: 2588,
          productName: '天然溫和清黑頭粉刺鼻頭貼',
          brandName: 'Ilso',
          rank: 6,
        },
        {
          productId: 34878,
          productName: '綠蕃茄瞬效緊緻毛孔精華',
          brandName: 'SUNGBOON EDITOR',
          rank: 7,
        },
        {
          productId: 3201,
          productName: '一步清潔棉片',
          brandName: 'Cosrx',
          rank: 8,
        },
        {
          productId: 35295,
          productName: 'ZERO微針全效毛孔安瓶 2,000ppm',
          brandName: 'Medicube',
          rank: 9,
        },
        {
          productId: 426,
          productName: 'PHA2 軟化角質爽膚水',
          brandName: 'factiv',
          rank: 10,
        },
      ],
      dry: [
        {
          productId: 464,
          productName: '護膚精華露 （神仙水）',
          brandName: 'SK-ll',
          rank: 1,
        },
        {
          productId: 623,
          productName: 'Soft Pads',
          brandName: 'Stridex',
          rank: 2,
        },
        {
          productId: 2795,
          productName: '夜間修復精華',
          brandName: 'YSL',
          rank: 3,
        },
        {
          productId: 3326,
          productName: 'VT 塗抹式微針精華 100',
          brandName: 'VT Cosmetics',
          rank: 4,
        },
        {
          productId: 34878,
          productName: '綠蕃茄瞬效緊緻毛孔精華',
          brandName: 'SUNGBOON EDITOR',
          rank: 5,
        },
        {
          productId: 2588,
          productName: '天然溫和清黑頭粉刺鼻頭貼',
          brandName: 'Ilso',
          rank: 6,
        },
        {
          productId: 82,
          productName: 'Obagi C10 維他命精華營養液',
          brandName: 'Dermacept',
          rank: 7,
        },
        {
          productId: 627,
          productName: '去印收毛孔精華',
          brandName: 'The Ordinary',
          rank: 8,
        },
        {
          productId: 426,
          productName: 'PHA2 軟化角質爽膚水',
          brandName: 'factiv',
          rank: 9,
        },
        {
          productId: 83,
          productName: '杏仁酸溫和煥膚精華8%',
          brandName: 'DR.WU',
          rank: 10,
        },
      ],
      oily: [
        {
          productId: 464,
          productName: '護膚精華露 （神仙水）',
          brandName: 'SK-ll',
          rank: 1,
        },
        {
          productId: 623,
          productName: 'Soft Pads',
          brandName: 'Stridex',
          rank: 2,
        },
        {
          productId: 3326,
          productName: 'VT 塗抹式微針精華 100',
          brandName: 'VT Cosmetics',
          rank: 3,
        },
        {
          productId: 2588,
          productName: '天然溫和清黑頭粉刺鼻頭貼',
          brandName: 'Ilso',
          rank: 4,
        },
        {
          productId: 2795,
          productName: '夜間修復精華',
          brandName: 'YSL',
          rank: 5,
        },
        {
          productId: 426,
          productName: 'PHA2 軟化角質爽膚水',
          brandName: 'factiv',
          rank: 6,
        },
        {
          productId: 466,
          productName: '煥采盈亮精華水',
          brandName: 'Tatcha',
          rank: 7,
        },
        {
          productId: 35620,
          productName: '65%低分子膠原蛋白水潤彈嫩面膜',
          brandName: 'Numbuzin',
          rank: 8,
        },
        {
          productId: 431,
          productName: '紅茶酵素抗氧精華水',
          brandName: 'Fresh',
          rank: 9,
        },
        {
          productId: 435,
          productName: '流金水',
          brandName: 'IPSA',
          rank: 10,
        },
      ],
      combination: [
        {
          productId: 464,
          productName: '護膚精華露 （神仙水）',
          brandName: 'SK-ll',
          rank: 1,
        },
        {
          productId: 3326,
          productName: 'VT 塗抹式微針精華 100',
          brandName: 'VT Cosmetics',
          rank: 2,
        },
        {
          productId: 623,
          productName: 'Soft Pads',
          brandName: 'Stridex',
          rank: 3,
        },
        {
          productId: 2588,
          productName: '天然溫和清黑頭粉刺鼻頭貼',
          brandName: 'Ilso',
          rank: 4,
        },
        {
          productId: 2795,
          productName: '夜間修復精華',
          brandName: 'YSL',
          rank: 5,
        },
        {
          productId: 34878,
          productName: '綠蕃茄瞬效緊緻毛孔精華',
          brandName: 'SUNGBOON EDITOR',
          rank: 6,
        },
        {
          productId: 435,
          productName: '流金水',
          brandName: 'IPSA',
          rank: 7,
        },
        {
          productId: 627,
          productName: '去印收毛孔精華',
          brandName: 'The Ordinary',
          rank: 8,
        },
        {
          productId: 82,
          productName: 'Obagi C10 維他命精華營養液',
          brandName: 'Dermacept',
          rank: 9,
        },
        {
          productId: 426,
          productName: 'PHA2 軟化角質爽膚水',
          brandName: 'factiv',
          rank: 10,
        },
      ],
      sensitive: [
        {
          productId: 464,
          productName: '護膚精華露 （神仙水）',
          brandName: 'SK-ll',
          rank: 1,
        },
        {
          productId: 2795,
          productName: '夜間修復精華',
          brandName: 'YSL',
          rank: 2,
        },
        {
          productId: 3326,
          productName: 'VT 塗抹式微針精華 100',
          brandName: 'VT Cosmetics',
          rank: 3,
        },
        {
          productId: 2588,
          productName: '天然溫和清黑頭粉刺鼻頭貼',
          brandName: 'Ilso',
          rank: 4,
        },
        {
          productId: 34878,
          productName: '綠蕃茄瞬效緊緻毛孔精華',
          brandName: 'SUNGBOON EDITOR',
          rank: 5,
        },
        {
          productId: 623,
          productName: 'Soft Pads',
          brandName: 'Stridex',
          rank: 6,
        },
        {
          productId: 82,
          productName: 'Obagi C10 維他命精華營養液',
          brandName: 'Dermacept',
          rank: 7,
        },
        {
          productId: 627,
          productName: '去印收毛孔精華',
          brandName: 'The Ordinary',
          rank: 8,
        },
        {
          productId: 426,
          productName: 'PHA2 軟化角質爽膚水',
          brandName: 'factiv',
          rank: 9,
        },
        {
          productId: 3201,
          productName: '一步清潔棉片',
          brandName: 'Cosrx',
          rank: 10,
        },
      ],
    },
  },
  {
    name: '提亮',
    key: 'brightening',
    factor: {
      overall: [
        {
          productId: 87,
          productName: '醫學維C淡斑精華',
          brandName: "Kiehl's",
          rank: 1,
        },
        {
          productId: 3124,
          productName: '水感透白光曜精華',
          brandName: 'Olay',
          rank: 2,
        },
        {
          productId: 29975,
          productName: '肌源鑽光精華',
          brandName: 'SK-ll',
          rank: 3,
        },
        {
          productId: 562,
          productName: '葡萄蔓極緻亮白精華液',
          brandName: 'Caudalie',
          rank: 4,
        },
        {
          productId: 92,
          productName: 'Niacinamide 10% + Zinc 1%',
          brandName: 'The Ordinary',
          rank: 5,
        },
        {
          productId: 26072,
          productName: 'PROX 亮潔晳顏淡斑精華 (新升級抗氧淡斑精華)',
          brandName: 'Olay',
          rank: 6,
        },
        {
          productId: 79,
          productName: '升級版勻淨科研亮白淡斑雙效精華',
          brandName: 'Clinique',
          rank: 7,
        },
        {
          productId: 35547,
          productName: '濟州青橘維C美白淡斑去痘印保濕精華',
          brandName: 'Goodal',
          rank: 8,
        },
        {
          productId: 82,
          productName: 'Obagi C10 維他命精華營養液',
          brandName: 'Dermacept',
          rank: 9,
        },
        {
          productId: 598,
          productName: '維他命B3精華',
          brandName: 'SYNERGIE SKIN',
          rank: 10,
        },
      ],
      neutral: [
        {
          productId: 87,
          productName: '醫學維C淡斑精華',
          brandName: "Kiehl's",
          rank: 1,
        },
        {
          productId: 3124,
          productName: '水感透白光曜精華',
          brandName: 'Olay',
          rank: 2,
        },
        {
          productId: 29975,
          productName: '肌源鑽光精華',
          brandName: 'SK-ll',
          rank: 3,
        },
        {
          productId: 92,
          productName: 'Niacinamide 10% + Zinc 1%',
          brandName: 'The Ordinary',
          rank: 4,
        },
        {
          productId: 79,
          productName: '升級版勻淨科研亮白淡斑雙效精華',
          brandName: 'Clinique',
          rank: 5,
        },
        {
          productId: 562,
          productName: '葡萄蔓極緻亮白精華液',
          brandName: 'Caudalie',
          rank: 6,
        },
        {
          productId: 2594,
          productName: '淨澈亮肌精華水',
          brandName: 'Lancome',
          rank: 7,
        },
        {
          productId: 35758,
          productName: '超微C美白精華液',
          brandName: 'DR.WU',
          rank: 8,
        },
        {
          productId: 35547,
          productName: '濟州青橘維C美白淡斑去痘印保濕精華',
          brandName: 'Goodal',
          rank: 9,
        },
        {
          productId: 26072,
          productName: 'PROX 亮潔晳顏淡斑精華 (新升級抗氧淡斑精華)',
          brandName: 'Olay',
          rank: 10,
        },
      ],
      dry: [
        {
          productId: 87,
          productName: '醫學維C淡斑精華',
          brandName: "Kiehl's",
          rank: 1,
        },
        {
          productId: 3124,
          productName: '水感透白光曜精華',
          brandName: 'Olay',
          rank: 2,
        },
        {
          productId: 29975,
          productName: '肌源鑽光精華',
          brandName: 'SK-ll',
          rank: 3,
        },
        {
          productId: 92,
          productName: 'Niacinamide 10% + Zinc 1%',
          brandName: 'The Ordinary',
          rank: 4,
        },
        {
          productId: 562,
          productName: '葡萄蔓極緻亮白精華液',
          brandName: 'Caudalie',
          rank: 5,
        },
        {
          productId: 35547,
          productName: '濟州青橘維C美白淡斑去痘印保濕精華',
          brandName: 'Goodal',
          rank: 6,
        },
        {
          productId: 82,
          productName: 'Obagi C10 維他命精華營養液',
          brandName: 'Dermacept',
          rank: 7,
        },
        {
          productId: 33399,
          productName: '維他命 C亮白精華',
          brandName: 'unlabel',
          rank: 8,
        },
        {
          productId: 2658,
          productName: '維他命A抗皺淨白面膜',
          brandName: 'The Preface 本木序',
          rank: 9,
        },
        {
          productId: 79,
          productName: '升級版勻淨科研亮白淡斑雙效精華',
          brandName: 'Clinique',
          rank: 10,
        },
      ],
      oily: [
        {
          productId: 3124,
          productName: '水感透白光曜精華',
          brandName: 'Olay',
          rank: 1,
        },
        {
          productId: 87,
          productName: '醫學維C淡斑精華',
          brandName: "Kiehl's",
          rank: 2,
        },
        {
          productId: 29975,
          productName: '肌源鑽光精華',
          brandName: 'SK-ll',
          rank: 3,
        },
        {
          productId: 562,
          productName: '葡萄蔓極緻亮白精華液',
          brandName: 'Caudalie',
          rank: 4,
        },
        {
          productId: 2658,
          productName: '維他命A抗皺淨白面膜',
          brandName: 'The Preface 本木序',
          rank: 5,
        },
        {
          productId: 35547,
          productName: '濟州青橘維C美白淡斑去痘印保濕精華',
          brandName: 'Goodal',
          rank: 6,
        },
        {
          productId: 92,
          productName: 'Niacinamide 10% + Zinc 1%',
          brandName: 'The Ordinary',
          rank: 7,
        },
        {
          productId: 79,
          productName: '升級版勻淨科研亮白淡斑雙效精華',
          brandName: 'Clinique',
          rank: 8,
        },
        {
          productId: 26072,
          productName: 'PROX 亮潔晳顏淡斑精華 (新升級抗氧淡斑精華)',
          brandName: 'Olay',
          rank: 9,
        },
        {
          productId: 35179,
          productName: 'Unlabel維他命C25高濃度亮白精華',
          brandName: 'unlabel',
          rank: 10,
        },
      ],
      combination: [
        {
          productId: 87,
          productName: '醫學維C淡斑精華',
          brandName: "Kiehl's",
          rank: 1,
        },
        {
          productId: 3124,
          productName: '水感透白光曜精華',
          brandName: 'Olay',
          rank: 2,
        },
        {
          productId: 29975,
          productName: '肌源鑽光精華',
          brandName: 'SK-ll',
          rank: 3,
        },
        {
          productId: 562,
          productName: '葡萄蔓極緻亮白精華液',
          brandName: 'Caudalie',
          rank: 4,
        },
        {
          productId: 26072,
          productName: 'PROX 亮潔晳顏淡斑精華 (新升級抗氧淡斑精華)',
          brandName: 'Olay',
          rank: 5,
        },
        {
          productId: 79,
          productName: '升級版勻淨科研亮白淡斑雙效精華',
          brandName: 'Clinique',
          rank: 6,
        },
        {
          productId: 35547,
          productName: '濟州青橘維C美白淡斑去痘印保濕精華',
          brandName: 'Goodal',
          rank: 7,
        },
        {
          productId: 92,
          productName: 'Niacinamide 10% + Zinc 1%',
          brandName: 'The Ordinary',
          rank: 8,
        },
        {
          productId: 598,
          productName: '維他命B3精華',
          brandName: 'SYNERGIE SKIN',
          rank: 9,
        },
        {
          productId: 2594,
          productName: '淨澈亮肌精華水',
          brandName: 'Lancome',
          rank: 10,
        },
      ],
      sensitive: [
        {
          productId: 87,
          productName: '醫學維C淡斑精華',
          brandName: "Kiehl's",
          rank: 1,
        },
        {
          productId: 3124,
          productName: '水感透白光曜精華',
          brandName: 'Olay',
          rank: 2,
        },
        {
          productId: 29975,
          productName: '肌源鑽光精華',
          brandName: 'SK-ll',
          rank: 3,
        },
        {
          productId: 79,
          productName: '升級版勻淨科研亮白淡斑雙效精華',
          brandName: 'Clinique',
          rank: 4,
        },
        {
          productId: 92,
          productName: 'Niacinamide 10% + Zinc 1%',
          brandName: 'The Ordinary',
          rank: 5,
        },
        {
          productId: 26072,
          productName: 'PROX 亮潔晳顏淡斑精華 (新升級抗氧淡斑精華)',
          brandName: 'Olay',
          rank: 6,
        },
        {
          productId: 562,
          productName: '葡萄蔓極緻亮白精華液',
          brandName: 'Caudalie',
          rank: 7,
        },
        {
          productId: 82,
          productName: 'Obagi C10 維他命精華營養液',
          brandName: 'Dermacept',
          rank: 8,
        },
        {
          productId: 2658,
          productName: '維他命A抗皺淨白面膜',
          brandName: 'The Preface 本木序',
          rank: 9,
        },
        {
          productId: 35547,
          productName: '濟州青橘維C美白淡斑去痘印保濕精華',
          brandName: 'Goodal',
          rank: 10,
        },
      ],
    },
  },
  {
    name: '抗衰老',
    key: 'antiaging',
    factor: {
      overall: [
        {
          productId: 572,
          productName: '升級再生基因修復精華（小棕瓶）',
          brandName: 'Estee Lauder',
          rank: 1,
        },
        {
          productId: 586,
          productName: 'Genifique 嫩肌活膚精華（小黑瓶）',
          brandName: 'Lancome',
          rank: 2,
        },
        {
          productId: 564,
          productName: '賦活雙精華',
          brandName: 'Clarins',
          rank: 3,
        },
        {
          productId: 431,
          productName: '紅茶酵素抗氧精華水',
          brandName: 'Fresh',
          rank: 4,
        },
        {
          productId: 193,
          productName: '黑繃帶修護乳霜',
          brandName: 'Helena Rubinstein',
          rank: 5,
        },
        {
          productId: 597,
          productName: '潤燥再生精華',
          brandName: 'Sulwhasoo 雪花秀',
          rank: 6,
        },
        {
          productId: 226,
          productName: 'R.N.A 超肌能緊緻活膚霜',
          brandName: 'SK-ll',
          rank: 7,
        },
        {
          productId: 35250,
          productName: '維A醇抗皺修護新生面霜',
          brandName: 'Neutrogena 露得清',
          rank: 8,
        },
        {
          productId: 2672,
          productName: '維他命A精華',
          brandName: 'SYNERGIE',
          rank: 9,
        },
        {
          productId: 35009,
          productName: '白松露活顏滋養修護面霜',
          brandName: 'XOVE',
          rank: 10,
        },
      ],
      neutral: [
        {
          productId: 572,
          productName: '升級再生基因修復精華（小棕瓶）',
          brandName: 'Estee Lauder',
          rank: 1,
        },
        {
          productId: 586,
          productName: 'Genifique 嫩肌活膚精華（小黑瓶）',
          brandName: 'Lancome',
          rank: 2,
        },
        {
          productId: 193,
          productName: '黑繃帶修護乳霜',
          brandName: 'Helena Rubinstein',
          rank: 3,
        },
        {
          productId: 564,
          productName: '賦活雙精華',
          brandName: 'Clarins',
          rank: 4,
        },
        {
          productId: 431,
          productName: '紅茶酵素抗氧精華水',
          brandName: 'Fresh',
          rank: 5,
        },
        {
          productId: 597,
          productName: '潤燥再生精華',
          brandName: 'Sulwhasoo 雪花秀',
          rank: 6,
        },
        {
          productId: 35677,
          productName: '超A醇煥顏緊緻精華1.5%',
          brandName: 'DR.WU',
          rank: 7,
        },
        {
          productId: 226,
          productName: 'R.N.A 超肌能緊緻活膚霜',
          brandName: 'SK-ll',
          rank: 8,
        },
        {
          productId: 26072,
          productName: 'PROX 亮潔晳顏淡斑精華 (新升級抗氧淡斑精華)',
          brandName: 'Olay',
          rank: 9,
        },
        {
          productId: 36679,
          productName: 'Nivea妮維雅Q10全方位抗糖抗皺精華 30毫升',
          brandName: 'Nivea',
          rank: 10,
        },
      ],
      dry: [
        {
          productId: 572,
          productName: '升級再生基因修復精華（小棕瓶）',
          brandName: 'Estee Lauder',
          rank: 1,
        },
        {
          productId: 586,
          productName: 'Genifique 嫩肌活膚精華（小黑瓶）',
          brandName: 'Lancome',
          rank: 2,
        },
        {
          productId: 193,
          productName: '黑繃帶修護乳霜',
          brandName: 'Helena Rubinstein',
          rank: 3,
        },
        {
          productId: 226,
          productName: 'R.N.A 超肌能緊緻活膚霜',
          brandName: 'SK-ll',
          rank: 4,
        },
        {
          productId: 564,
          productName: '賦活雙精華',
          brandName: 'Clarins',
          rank: 5,
        },
        {
          productId: 26072,
          productName: 'PROX 亮潔晳顏淡斑精華 (新升級抗氧淡斑精華)',
          brandName: 'Olay',
          rank: 6,
        },
        {
          productId: 35250,
          productName: '維A醇抗皺修護新生面霜',
          brandName: 'Neutrogena 露得清',
          rank: 7,
        },
        {
          productId: 597,
          productName: '潤燥再生精華',
          brandName: 'Sulwhasoo 雪花秀',
          rank: 8,
        },
        {
          productId: 431,
          productName: '紅茶酵素抗氧精華水',
          brandName: 'Fresh',
          rank: 9,
        },
        {
          productId: 2672,
          productName: '維他命A精華',
          brandName: 'SYNERGIE',
          rank: 10,
        },
      ],
      oily: [
        {
          productId: 572,
          productName: '升級再生基因修復精華（小棕瓶）',
          brandName: 'Estee Lauder',
          rank: 1,
        },
        {
          productId: 564,
          productName: '賦活雙精華',
          brandName: 'Clarins',
          rank: 2,
        },
        {
          productId: 431,
          productName: '紅茶酵素抗氧精華水',
          brandName: 'Fresh',
          rank: 3,
        },
        {
          productId: 586,
          productName: 'Genifique 嫩肌活膚精華（小黑瓶）',
          brandName: 'Lancome',
          rank: 4,
        },
        {
          productId: 193,
          productName: '黑繃帶修護乳霜',
          brandName: 'Helena Rubinstein',
          rank: 5,
        },
        {
          productId: 2672,
          productName: '維他命A精華',
          brandName: 'SYNERGIE',
          rank: 6,
        },
        {
          productId: 597,
          productName: '潤燥再生精華',
          brandName: 'Sulwhasoo 雪花秀',
          rank: 7,
        },
        {
          productId: 226,
          productName: 'R.N.A 超肌能緊緻活膚霜',
          brandName: 'SK-ll',
          rank: 8,
        },
        {
          productId: 35250,
          productName: '維A醇抗皺修護新生面霜',
          brandName: 'Neutrogena 露得清',
          rank: 9,
        },
        {
          productId: 30919,
          productName: 'N.28 極效緊致抗衰老精華 Ultra Firming Drops',
          brandName: 'Starrytale',
          rank: 10,
        },
      ],
      combination: [
        {
          productId: 572,
          productName: '升級再生基因修復精華（小棕瓶）',
          brandName: 'Estee Lauder',
          rank: 1,
        },
        {
          productId: 586,
          productName: 'Genifique 嫩肌活膚精華（小黑瓶）',
          brandName: 'Lancome',
          rank: 2,
        },
        {
          productId: 564,
          productName: '賦活雙精華',
          brandName: 'Clarins',
          rank: 3,
        },
        {
          productId: 431,
          productName: '紅茶酵素抗氧精華水',
          brandName: 'Fresh',
          rank: 4,
        },
        {
          productId: 193,
          productName: '黑繃帶修護乳霜',
          brandName: 'Helena Rubinstein',
          rank: 5,
        },
        {
          productId: 597,
          productName: '潤燥再生精華',
          brandName: 'Sulwhasoo 雪花秀',
          rank: 6,
        },
        {
          productId: 226,
          productName: 'R.N.A 超肌能緊緻活膚霜',
          brandName: 'SK-ll',
          rank: 7,
        },
        {
          productId: 35250,
          productName: '維A醇抗皺修護新生面霜',
          brandName: 'Neutrogena 露得清',
          rank: 8,
        },
        {
          productId: 2672,
          productName: '維他命A精華',
          brandName: 'SYNERGIE',
          rank: 9,
        },
        {
          productId: 36163,
          productName: 'Neutrogena 維A醇抗皺修護精華 30毫升',
          brandName: 'Neutrogena 露得清',
          rank: 10,
        },
      ],
      sensitive: [
        {
          productId: 572,
          productName: '升級再生基因修復精華（小棕瓶）',
          brandName: 'Estee Lauder',
          rank: 1,
        },
        {
          productId: 564,
          productName: '賦活雙精華',
          brandName: 'Clarins',
          rank: 2,
        },
        {
          productId: 586,
          productName: 'Genifique 嫩肌活膚精華（小黑瓶）',
          brandName: 'Lancome',
          rank: 3,
        },
        {
          productId: 597,
          productName: '潤燥再生精華',
          brandName: 'Sulwhasoo 雪花秀',
          rank: 4,
        },
        {
          productId: 431,
          productName: '紅茶酵素抗氧精華水',
          brandName: 'Fresh',
          rank: 5,
        },
        {
          productId: 193,
          productName: '黑繃帶修護乳霜',
          brandName: 'Helena Rubinstein',
          rank: 6,
        },
        {
          productId: 226,
          productName: 'R.N.A 超肌能緊緻活膚霜',
          brandName: 'SK-ll',
          rank: 7,
        },
        {
          productId: 35250,
          productName: '維A醇抗皺修護新生面霜',
          brandName: 'Neutrogena 露得清',
          rank: 8,
        },
        {
          productId: 566,
          productName: '全效舒緩維生肌底精華',
          brandName: 'DARPHIN',
          rank: 9,
        },
        {
          productId: 2672,
          productName: '維他命A精華',
          brandName: 'SYNERGIE',
          rank: 10,
        },
      ],
    },
  },
  {
    name: '暗瘡護理',
    key: 'acnecare',
    factor: {
      overall: [
        {
          productId: 2006,
          productName: '隱形痘痘暗瘡貼',
          brandName: 'Olive Young',
          rank: 1,
        },
        {
          productId: 1183,
          productName: '祛痘精華溫和版',
          brandName: 'Mario Badescu',
          rank: 2,
        },
        {
          productId: 454,
          productName: '靈芝菇菌抗逆健膚紓緩水',
          brandName: 'Origins',
          rank: 3,
        },
        {
          productId: 626,
          productName: '茶樹油',
          brandName: 'The Body Shop',
          rank: 4,
        },
        {
          productId: 616,
          productName: 'Pair暗瘡膏',
          brandName: 'Lion 獅王',
          rank: 5,
        },
        {
          productId: 1187,
          productName: '快治暗瘡膏',
          brandName: 'Oxy',
          rank: 6,
        },
        {
          productId: 35606,
          productName: '醫學水楊酸抗粉刺精華液體貼',
          brandName: "Kiehl's",
          rank: 7,
        },
        {
          productId: 623,
          productName: 'Soft Pads',
          brandName: 'Stridex',
          rank: 8,
        },
        {
          productId: 1998,
          productName: '樂膚潔抗菌痘痘貼',
          brandName: '曼秀雷敦 Mentholatum',
          rank: 9,
        },
        {
          productId: 3322,
          productName: '皇牌消炎急救霜 ',
          brandName: 'Starrytale',
          rank: 10,
        },
      ],
      neutral: [
        {
          productId: 626,
          productName: '茶樹油',
          brandName: 'The Body Shop',
          rank: 1,
        },
        {
          productId: 2006,
          productName: '隱形痘痘暗瘡貼',
          brandName: 'Olive Young',
          rank: 2,
        },
        {
          productId: 1183,
          productName: '祛痘精華溫和版',
          brandName: 'Mario Badescu',
          rank: 3,
        },
        {
          productId: 35606,
          productName: '醫學水楊酸抗粉刺精華液體貼',
          brandName: "Kiehl's",
          rank: 4,
        },
        {
          productId: 616,
          productName: 'Pair暗瘡膏',
          brandName: 'Lion 獅王',
          rank: 5,
        },
        {
          productId: 1187,
          productName: '快治暗瘡膏',
          brandName: 'Oxy',
          rank: 6,
        },
        {
          productId: 623,
          productName: 'Soft Pads',
          brandName: 'Stridex',
          rank: 7,
        },
        {
          productId: 454,
          productName: '靈芝菇菌抗逆健膚紓緩水',
          brandName: 'Origins',
          rank: 8,
        },
        {
          productId: 7254,
          productName:
            '麥蘆卡消炎抗菌原液 Skin Clarifier No. 75 - Pore & Oil Control',
          brandName: 'Bobbi Brown',
          rank: 9,
        },
        {
          productId: 2600,
          productName: '曼秀雷敦Acnes痘痘貼-隱透型',
          brandName: '曼秀雷敦 Mentholatum',
          rank: 10,
        },
      ],
      dry: [
        {
          productId: 2006,
          productName: '隱形痘痘暗瘡貼',
          brandName: 'Olive Young',
          rank: 1,
        },
        {
          productId: 626,
          productName: '茶樹油',
          brandName: 'The Body Shop',
          rank: 2,
        },
        {
          productId: 1183,
          productName: '祛痘精華溫和版',
          brandName: 'Mario Badescu',
          rank: 3,
        },
        {
          productId: 616,
          productName: 'Pair暗瘡膏',
          brandName: 'Lion 獅王',
          rank: 4,
        },
        {
          productId: 623,
          productName: 'Soft Pads',
          brandName: 'Stridex',
          rank: 5,
        },
        {
          productId: 454,
          productName: '靈芝菇菌抗逆健膚紓緩水',
          brandName: 'Origins',
          rank: 6,
        },
        {
          productId: 1187,
          productName: '快治暗瘡膏',
          brandName: 'Oxy',
          rank: 7,
        },
        {
          productId: 2600,
          productName: '曼秀雷敦Acnes痘痘貼-隱透型',
          brandName: '曼秀雷敦 Mentholatum',
          rank: 8,
        },
        {
          productId: 35606,
          productName: '醫學水楊酸抗粉刺精華液體貼',
          brandName: "Kiehl's",
          rank: 9,
        },
        {
          productId: 1180,
          productName: '粉刺淨化雙效精華',
          brandName: 'La Roche-Posay',
          rank: 10,
        },
      ],
      oily: [
        {
          productId: 2006,
          productName: '隱形痘痘暗瘡貼',
          brandName: 'Olive Young',
          rank: 1,
        },
        {
          productId: 626,
          productName: '茶樹油',
          brandName: 'The Body Shop',
          rank: 2,
        },
        {
          productId: 1183,
          productName: '祛痘精華溫和版',
          brandName: 'Mario Badescu',
          rank: 3,
        },
        {
          productId: 616,
          productName: 'Pair暗瘡膏',
          brandName: 'Lion 獅王',
          rank: 4,
        },
        {
          productId: 35606,
          productName: '醫學水楊酸抗粉刺精華液體貼',
          brandName: "Kiehl's",
          rank: 5,
        },
        {
          productId: 454,
          productName: '靈芝菇菌抗逆健膚紓緩水',
          brandName: 'Origins',
          rank: 6,
        },
        {
          productId: 1187,
          productName: '快治暗瘡膏',
          brandName: 'Oxy',
          rank: 7,
        },
        {
          productId: 3322,
          productName: '皇牌消炎急救霜 ',
          brandName: 'Starrytale',
          rank: 8,
        },
        {
          productId: 7254,
          productName:
            '麥蘆卡消炎抗菌原液 Skin Clarifier No. 75 - Pore & Oil Control',
          brandName: 'Bobbi Brown',
          rank: 9,
        },
        {
          productId: 623,
          productName: 'Soft Pads',
          brandName: 'Stridex',
          rank: 10,
        },
      ],
      combination: [
        {
          productId: 2006,
          productName: '隱形痘痘暗瘡貼',
          brandName: 'Olive Young',
          rank: 1,
        },
        {
          productId: 626,
          productName: '茶樹油',
          brandName: 'The Body Shop',
          rank: 2,
        },
        {
          productId: 1183,
          productName: '祛痘精華溫和版',
          brandName: 'Mario Badescu',
          rank: 3,
        },
        {
          productId: 616,
          productName: 'Pair暗瘡膏',
          brandName: 'Lion 獅王',
          rank: 4,
        },
        {
          productId: 35606,
          productName: '醫學水楊酸抗粉刺精華液體貼',
          brandName: "Kiehl's",
          rank: 5,
        },
        {
          productId: 454,
          productName: '靈芝菇菌抗逆健膚紓緩水',
          brandName: 'Origins',
          rank: 6,
        },
        {
          productId: 1187,
          productName: '快治暗瘡膏',
          brandName: 'Oxy',
          rank: 7,
        },
        {
          productId: 3322,
          productName: '皇牌消炎急救霜 ',
          brandName: 'Starrytale',
          rank: 8,
        },
        {
          productId: 7254,
          productName:
            '麥蘆卡消炎抗菌原液 Skin Clarifier No. 75 - Pore & Oil Control',
          brandName: 'Bobbi Brown',
          rank: 9,
        },
        {
          productId: 623,
          productName: 'Soft Pads',
          brandName: 'Stridex',
          rank: 10,
        },
      ],
      sensitive: [
        {
          productId: 2006,
          productName: '隱形痘痘暗瘡貼',
          brandName: 'Olive Young',
          rank: 1,
        },
        {
          productId: 626,
          productName: '茶樹油',
          brandName: 'The Body Shop',
          rank: 2,
        },
        {
          productId: 1183,
          productName: '祛痘精華溫和版',
          brandName: 'Mario Badescu',
          rank: 3,
        },
        {
          productId: 616,
          productName: 'Pair暗瘡膏',
          brandName: 'Lion 獅王',
          rank: 4,
        },
        {
          productId: 35606,
          productName: '醫學水楊酸抗粉刺精華液體貼',
          brandName: "Kiehl's",
          rank: 5,
        },
        {
          productId: 454,
          productName: '靈芝菇菌抗逆健膚紓緩水',
          brandName: 'Origins',
          rank: 6,
        },
        {
          productId: 1187,
          productName: '快治暗瘡膏',
          brandName: 'Oxy',
          rank: 7,
        },
        {
          productId: 3322,
          productName: '皇牌消炎急救霜 ',
          brandName: 'Starrytale',
          rank: 8,
        },
        {
          productId: 7254,
          productName:
            '麥蘆卡消炎抗菌原液 Skin Clarifier No. 75 - Pore & Oil Control',
          brandName: 'Bobbi Brown',
          rank: 9,
        },
        {
          productId: 623,
          productName: 'Soft Pads',
          brandName: 'Stridex',
          rank: 10,
        },
      ],
    },
  },
  {
    name: '舒緩',
    key: 'calming',
    factor: {
      overall: [
        {
          productId: 615,
          productName: 'B5萬用修復霜',
          brandName: 'La Roche-Posay',
          rank: 1,
        },
        {
          productId: 413,
          productName: '抗敏活泉水',
          brandName: 'Avene',
          rank: 2,
        },
        {
          productId: 170,
          productName: '深層高效保濕面霜',
          brandName: 'Curel',
          rank: 3,
        },
        {
          productId: 165,
          productName: '長效滋潤修復霜',
          brandName: 'CeraVe',
          rank: 4,
        },
        {
          productId: 449,
          productName: '敏感肌化妝水',
          brandName: 'Muji',
          rank: 5,
        },
        {
          productId: 438,
          productName: '金盞花植物精華爽膚水',
          brandName: "Kiehl's",
          rank: 6,
        },
        {
          productId: 220,
          productName: '潔美淨抗敏紓緩乳霜',
          brandName: 'Physiogel',
          rank: 7,
        },
        {
          productId: 176,
          productName: '泛紅修復凈化舒緩面霜',
          brandName: 'DR.G',
          rank: 8,
        },
        {
          productId: 225,
          productName: '升級版全能乳液',
          brandName: 'Sisley',
          rank: 9,
        },
        {
          productId: 548,
          productName: '積雪草修復面膜',
          brandName: 'Vecs Gardenia 嘉丹妮爾',
          rank: 10,
        },
      ],
      neutral: [
        {
          productId: 615,
          productName: 'B5萬用修復霜',
          brandName: 'La Roche-Posay',
          rank: 1,
        },
        {
          productId: 165,
          productName: '長效滋潤修復霜',
          brandName: 'CeraVe',
          rank: 2,
        },
        {
          productId: 413,
          productName: '抗敏活泉水',
          brandName: 'Avene',
          rank: 3,
        },
        {
          productId: 170,
          productName: '深層高效保濕面霜',
          brandName: 'Curel',
          rank: 4,
        },
        {
          productId: 176,
          productName: '泛紅修復凈化舒緩面霜',
          brandName: 'DR.G',
          rank: 5,
        },
        {
          productId: 438,
          productName: '金盞花植物精華爽膚水',
          brandName: "Kiehl's",
          rank: 6,
        },
        {
          productId: 220,
          productName: '潔美淨抗敏紓緩乳霜',
          brandName: 'Physiogel',
          rank: 7,
        },
        {
          productId: 439,
          productName: '肌底修護液',
          brandName: 'La Mer',
          rank: 8,
        },
        {
          productId: 225,
          productName: '升級版全能乳液',
          brandName: 'Sisley',
          rank: 9,
        },
        {
          productId: 547,
          productName: '金盞花舒緩保濕面膜',
          brandName: 'Vecs Gardenia 嘉丹妮爾',
          rank: 10,
        },
      ],
      dry: [
        {
          productId: 615,
          productName: 'B5萬用修復霜',
          brandName: 'La Roche-Posay',
          rank: 1,
        },
        {
          productId: 413,
          productName: '抗敏活泉水',
          brandName: 'Avene',
          rank: 2,
        },
        {
          productId: 165,
          productName: '長效滋潤修復霜',
          brandName: 'CeraVe',
          rank: 3,
        },
        {
          productId: 438,
          productName: '金盞花植物精華爽膚水',
          brandName: "Kiehl's",
          rank: 4,
        },
        {
          productId: 449,
          productName: '敏感肌化妝水',
          brandName: 'Muji',
          rank: 5,
        },
        {
          productId: 170,
          productName: '深層高效保濕面霜',
          brandName: 'Curel',
          rank: 6,
        },
        {
          productId: 1269,
          productName: '馬達加斯加積雪草精華液',
          brandName: 'Skin1004',
          rank: 7,
        },
        {
          productId: 220,
          productName: '潔美淨抗敏紓緩乳霜',
          brandName: 'Physiogel',
          rank: 8,
        },
        {
          productId: 176,
          productName: '泛紅修復凈化舒緩面霜',
          brandName: 'DR.G',
          rank: 9,
        },
        {
          productId: 2132,
          productName: '茶樹舒緩護理保濕導入精華面膜',
          brandName: 'Mediheal',
          rank: 10,
        },
      ],
      oily: [
        {
          productId: 615,
          productName: 'B5萬用修復霜',
          brandName: 'La Roche-Posay',
          rank: 1,
        },
        {
          productId: 170,
          productName: '深層高效保濕面霜',
          brandName: 'Curel',
          rank: 2,
        },
        {
          productId: 413,
          productName: '抗敏活泉水',
          brandName: 'Avene',
          rank: 3,
        },
        {
          productId: 165,
          productName: '長效滋潤修復霜',
          brandName: 'CeraVe',
          rank: 4,
        },
        {
          productId: 449,
          productName: '敏感肌化妝水',
          brandName: 'Muji',
          rank: 5,
        },
        {
          productId: 176,
          productName: '泛紅修復凈化舒緩面霜',
          brandName: 'DR.G',
          rank: 6,
        },
        {
          productId: 225,
          productName: '升級版全能乳液',
          brandName: 'Sisley',
          rank: 7,
        },
        {
          productId: 438,
          productName: '金盞花植物精華爽膚水',
          brandName: "Kiehl's",
          rank: 8,
        },
        {
          productId: 220,
          productName: '潔美淨抗敏紓緩乳霜',
          brandName: 'Physiogel',
          rank: 9,
        },
        {
          productId: 181,
          productName: 'CRM3紓敏修復面霜',
          brandName: 'factiv',
          rank: 10,
        },
      ],
      combination: [
        {
          productId: 615,
          productName: 'B5萬用修復霜',
          brandName: 'La Roche-Posay',
          rank: 1,
        },
        {
          productId: 170,
          productName: '深層高效保濕面霜',
          brandName: 'Curel',
          rank: 2,
        },
        {
          productId: 413,
          productName: '抗敏活泉水',
          brandName: 'Avene',
          rank: 3,
        },
        {
          productId: 165,
          productName: '長效滋潤修復霜',
          brandName: 'CeraVe',
          rank: 4,
        },
        {
          productId: 176,
          productName: '泛紅修復凈化舒緩面霜',
          brandName: 'DR.G',
          rank: 5,
        },
        {
          productId: 438,
          productName: '金盞花植物精華爽膚水',
          brandName: "Kiehl's",
          rank: 6,
        },
        {
          productId: 449,
          productName: '敏感肌化妝水',
          brandName: 'Muji',
          rank: 7,
        },
        {
          productId: 220,
          productName: '潔美淨抗敏紓緩乳霜',
          brandName: 'Physiogel',
          rank: 8,
        },
        {
          productId: 225,
          productName: '升級版全能乳液',
          brandName: 'Sisley',
          rank: 9,
        },
        {
          productId: 2146,
          productName: 'N.3皇牌全效面膜',
          brandName: 'Starrytale',
          rank: 10,
        },
      ],
      sensitive: [
        {
          productId: 615,
          productName: 'B5萬用修復霜',
          brandName: 'La Roche-Posay',
          rank: 1,
        },
        {
          productId: 413,
          productName: '抗敏活泉水',
          brandName: 'Avene',
          rank: 2,
        },
        {
          productId: 170,
          productName: '深層高效保濕面霜',
          brandName: 'Curel',
          rank: 3,
        },
        {
          productId: 165,
          productName: '長效滋潤修復霜',
          brandName: 'CeraVe',
          rank: 4,
        },
        {
          productId: 438,
          productName: '金盞花植物精華爽膚水',
          brandName: "Kiehl's",
          rank: 5,
        },
        {
          productId: 449,
          productName: '敏感肌化妝水',
          brandName: 'Muji',
          rank: 6,
        },
        {
          productId: 220,
          productName: '潔美淨抗敏紓緩乳霜',
          brandName: 'Physiogel',
          rank: 7,
        },
        {
          productId: 176,
          productName: '泛紅修復凈化舒緩面霜',
          brandName: 'DR.G',
          rank: 8,
        },
        {
          productId: 548,
          productName: '積雪草修復面膜',
          brandName: 'Vecs Gardenia 嘉丹妮爾',
          rank: 9,
        },
        {
          productId: 493,
          productName: '舒緩保濕綠藥丸抗敏面膜',
          brandName: 'Dr.Jart',
          rank: 10,
        },
      ],
    },
  },
  {
    name: '清潔',
    key: 'cleansing',
    factor: {
      overall: [
        {
          productId: 23,
          productName: '豐盈泡沫潔面乳',
          brandName: 'Curel',
          rank: 1,
        },
        {
          productId: 37,
          productName: '大豆卸妝潔面乳',
          brandName: 'Fresh',
          rank: 2,
        },
        {
          productId: 275,
          productName: '防敏護理系列-深層卸妝潔膚水',
          brandName: 'Bioderma',
          rank: 3,
        },
        {
          productId: 16,
          productName: '溫和潔膚露',
          brandName: 'Cetaphil',
          rank: 4,
        },
        {
          productId: 19,
          productName: '鉑鑽柔膚潔面泡沫',
          brandName: 'Cle De Peau',
          rank: 5,
        },
        {
          productId: 36,
          productName: '溫和淨潤皂霜',
          brandName: 'Freeplus',
          rank: 6,
        },
        {
          productId: 36566,
          productName: '清新綠茶卸妝潔面乳',
          brandName: 'Arencia',
          rank: 7,
        },
        {
          productId: 291,
          productName: 'MCO納米卸妝液',
          brandName: 'Fancl',
          rank: 8,
        },
        {
          productId: 267,
          productName: '緻柔卸妝膏',
          brandName: 'Banila Co.',
          rank: 9,
        },
        {
          productId: 2561,
          productName: 'CAT1 離子保濕淨膚乳',
          brandName: 'factiv',
          rank: 10,
        },
      ],
      neutral: [
        {
          productId: 23,
          productName: '豐盈泡沫潔面乳',
          brandName: 'Curel',
          rank: 1,
        },
        {
          productId: 37,
          productName: '大豆卸妝潔面乳',
          brandName: 'Fresh',
          rank: 2,
        },
        {
          productId: 275,
          productName: '防敏護理系列-深層卸妝潔膚水',
          brandName: 'Bioderma',
          rank: 3,
        },
        {
          productId: 19,
          productName: '鉑鑽柔膚潔面泡沫',
          brandName: 'Cle De Peau',
          rank: 4,
        },
        {
          productId: 36,
          productName: '溫和淨潤皂霜',
          brandName: 'Freeplus',
          rank: 5,
        },
        {
          productId: 267,
          productName: '緻柔卸妝膏',
          brandName: 'Banila Co.',
          rank: 6,
        },
        {
          productId: 16,
          productName: '溫和潔膚露',
          brandName: 'Cetaphil',
          rank: 7,
        },
        {
          productId: 36566,
          productName: '清新綠茶卸妝潔面乳',
          brandName: 'Arencia',
          rank: 8,
        },
        {
          productId: 6627,
          productName: '全效保濕卸妝液',
          brandName: 'Bifesta',
          rank: 9,
        },
        {
          productId: 2489,
          productName: '溫和潔面啫喱 ',
          brandName: 'Grown Alchemist',
          rank: 10,
        },
      ],
      dry: [
        {
          productId: 23,
          productName: '豐盈泡沫潔面乳',
          brandName: 'Curel',
          rank: 1,
        },
        {
          productId: 275,
          productName: '防敏護理系列-深層卸妝潔膚水',
          brandName: 'Bioderma',
          rank: 2,
        },
        {
          productId: 37,
          productName: '大豆卸妝潔面乳',
          brandName: 'Fresh',
          rank: 3,
        },
        {
          productId: 36,
          productName: '溫和淨潤皂霜',
          brandName: 'Freeplus',
          rank: 4,
        },
        {
          productId: 19,
          productName: '鉑鑽柔膚潔面泡沫',
          brandName: 'Cle De Peau',
          rank: 5,
        },
        {
          productId: 267,
          productName: '緻柔卸妝膏',
          brandName: 'Banila Co.',
          rank: 6,
        },
        {
          productId: 16,
          productName: '溫和潔膚露',
          brandName: 'Cetaphil',
          rank: 7,
        },
        {
          productId: 36566,
          productName: '清新綠茶卸妝潔面乳',
          brandName: 'Arencia',
          rank: 8,
        },
        {
          productId: 5693,
          productName: '礦泥潔面乳',
          brandName: 'B.glen',
          rank: 9,
        },
        {
          productId: 2561,
          productName: 'CAT1 離子保濕淨膚乳',
          brandName: 'factiv',
          rank: 10,
        },
      ],
      oily: [
        {
          productId: 23,
          productName: '豐盈泡沫潔面乳',
          brandName: 'Curel',
          rank: 1,
        },
        {
          productId: 37,
          productName: '大豆卸妝潔面乳',
          brandName: 'Fresh',
          rank: 2,
        },
        {
          productId: 19,
          productName: '鉑鑽柔膚潔面泡沫',
          brandName: 'Cle De Peau',
          rank: 3,
        },
        {
          productId: 275,
          productName: '防敏護理系列-深層卸妝潔膚水',
          brandName: 'Bioderma',
          rank: 4,
        },
        {
          productId: 36566,
          productName: '清新綠茶卸妝潔面乳',
          brandName: 'Arencia',
          rank: 5,
        },
        {
          productId: 16,
          productName: '溫和潔膚露',
          brandName: 'Cetaphil',
          rank: 6,
        },
        {
          productId: 36,
          productName: '溫和淨潤皂霜',
          brandName: 'Freeplus',
          rank: 7,
        },
        {
          productId: 267,
          productName: '緻柔卸妝膏',
          brandName: 'Banila Co.',
          rank: 8,
        },
        {
          productId: 34898,
          productName: 'Melano CC 維C酵素深層潔面乳',
          brandName: '樂敦',
          rank: 9,
        },
        {
          productId: 5693,
          productName: '礦泥潔面乳',
          brandName: 'B.glen',
          rank: 10,
        },
      ],
      combination: [
        {
          productId: 23,
          productName: '豐盈泡沫潔面乳',
          brandName: 'Curel',
          rank: 1,
        },
        {
          productId: 37,
          productName: '大豆卸妝潔面乳',
          brandName: 'Fresh',
          rank: 2,
        },
        {
          productId: 16,
          productName: '溫和潔膚露',
          brandName: 'Cetaphil',
          rank: 3,
        },
        {
          productId: 275,
          productName: '防敏護理系列-深層卸妝潔膚水',
          brandName: 'Bioderma',
          rank: 4,
        },
        {
          productId: 36,
          productName: '溫和淨潤皂霜',
          brandName: 'Freeplus',
          rank: 5,
        },
        {
          productId: 19,
          productName: '鉑鑽柔膚潔面泡沫',
          brandName: 'Cle De Peau',
          rank: 6,
        },
        {
          productId: 291,
          productName: 'MCO納米卸妝液',
          brandName: 'Fancl',
          rank: 7,
        },
        {
          productId: 36566,
          productName: '清新綠茶卸妝潔面乳',
          brandName: 'Arencia',
          rank: 8,
        },
        {
          productId: 267,
          productName: '緻柔卸妝膏',
          brandName: 'Banila Co.',
          rank: 9,
        },
        {
          productId: 6627,
          productName: '全效保濕卸妝液',
          brandName: 'Bifesta',
          rank: 10,
        },
      ],
      sensitive: [
        {
          productId: 23,
          productName: '豐盈泡沫潔面乳',
          brandName: 'Curel',
          rank: 1,
        },
        {
          productId: 16,
          productName: '溫和潔膚露',
          brandName: 'Cetaphil',
          rank: 2,
        },
        {
          productId: 275,
          productName: '防敏護理系列-深層卸妝潔膚水',
          brandName: 'Bioderma',
          rank: 3,
        },
        {
          productId: 37,
          productName: '大豆卸妝潔面乳',
          brandName: 'Fresh',
          rank: 4,
        },
        {
          productId: 19,
          productName: '鉑鑽柔膚潔面泡沫',
          brandName: 'Cle De Peau',
          rank: 5,
        },
        {
          productId: 36,
          productName: '溫和淨潤皂霜',
          brandName: 'Freeplus',
          rank: 6,
        },
        {
          productId: 36566,
          productName: '清新綠茶卸妝潔面乳',
          brandName: 'Arencia',
          rank: 7,
        },
        {
          productId: 267,
          productName: '緻柔卸妝膏',
          brandName: 'Banila Co.',
          rank: 8,
        },
        {
          productId: 291,
          productName: 'MCO納米卸妝液',
          brandName: 'Fancl',
          rank: 9,
        },
        {
          productId: 2561,
          productName: 'CAT1 離子保濕淨膚乳',
          brandName: 'factiv',
          rank: 10,
        },
      ],
    },
  },
  {
    name: '淡斑',
    key: 'darkspotcare',
    factor: {
      overall: [
        {
          productId: 87,
          productName: '醫學維C淡斑精華',
          brandName: "Kiehl's",
          rank: 1,
        },
        {
          productId: 26072,
          productName: 'PROX 亮潔晳顏淡斑精華 (新升級抗氧淡斑精華)',
          brandName: 'Olay',
          rank: 2,
        },
        {
          productId: 562,
          productName: '葡萄蔓極緻亮白精華液',
          brandName: 'Caudalie',
          rank: 3,
        },
        {
          productId: 33399,
          productName: '維他命 C亮白精華',
          brandName: 'unlabel',
          rank: 4,
        },
        {
          productId: 81,
          productName: 'Obagi C20 維他命精華營養液',
          brandName: 'Dermacept',
          rank: 5,
        },
        {
          productId: 29975,
          productName: '肌源鑽光精華',
          brandName: 'SK-ll',
          rank: 6,
        },
        {
          productId: 79,
          productName: '升級版勻淨科研亮白淡斑雙效精華',
          brandName: 'Clinique',
          rank: 7,
        },
        {
          productId: 34836,
          productName: '維他命C綠茶酵素透亮精華 (維C極光精華)',
          brandName: 'Innisfree',
          rank: 8,
        },
        {
          productId: 613,
          productName: 'EAA20亮白抗氧精華',
          brandName: 'factiv',
          rank: 9,
        },
        {
          productId: 28363,
          productName: 'MELANO CC 特濃純維C精華',
          brandName: '樂敦',
          rank: 10,
        },
      ],
      neutral: [
        {
          productId: 87,
          productName: '醫學維C淡斑精華',
          brandName: "Kiehl's",
          rank: 1,
        },
        {
          productId: 562,
          productName: '葡萄蔓極緻亮白精華液',
          brandName: 'Caudalie',
          rank: 2,
        },
        {
          productId: 613,
          productName: 'EAA20亮白抗氧精華',
          brandName: 'factiv',
          rank: 3,
        },
        {
          productId: 25642,
          productName: 'Luminous630 雙效淡斑透白精華',
          brandName: 'Nivea',
          rank: 4,
        },
        {
          productId: 79,
          productName: '升級版勻淨科研亮白淡斑雙效精華',
          brandName: 'Clinique',
          rank: 5,
        },
        {
          productId: 29975,
          productName: '肌源鑽光精華',
          brandName: 'SK-ll',
          rank: 6,
        },
        {
          productId: 33399,
          productName: '維他命 C亮白精華',
          brandName: 'unlabel',
          rank: 7,
        },
        {
          productId: 34836,
          productName: '維他命C綠茶酵素透亮精華 (維C極光精華)',
          brandName: 'Innisfree',
          rank: 8,
        },
        {
          productId: 26072,
          productName: 'PROX 亮潔晳顏淡斑精華 (新升級抗氧淡斑精華)',
          brandName: 'Olay',
          rank: 9,
        },
        {
          productId: 34290,
          productName: '煥白淨斑精華',
          brandName: 'XOVE',
          rank: 10,
        },
      ],
      dry: [
        {
          productId: 87,
          productName: '醫學維C淡斑精華',
          brandName: "Kiehl's",
          rank: 1,
        },
        {
          productId: 33399,
          productName: '維他命 C亮白精華',
          brandName: 'unlabel',
          rank: 2,
        },
        {
          productId: 562,
          productName: '葡萄蔓極緻亮白精華液',
          brandName: 'Caudalie',
          rank: 3,
        },
        {
          productId: 29975,
          productName: '肌源鑽光精華',
          brandName: 'SK-ll',
          rank: 4,
        },
        {
          productId: 28363,
          productName: 'MELANO CC 特濃純維C精華',
          brandName: '樂敦',
          rank: 5,
        },
        {
          productId: 26072,
          productName: 'PROX 亮潔晳顏淡斑精華 (新升級抗氧淡斑精華)',
          brandName: 'Olay',
          rank: 6,
        },
        {
          productId: 231,
          productName: '亮肌淡斑',
          brandName: 'The Ordinary',
          rank: 7,
        },
        {
          productId: 35750,
          productName: 'PROX 皙顏袪斑精華液',
          brandName: 'Olay',
          rank: 8,
        },
        {
          productId: 81,
          productName: 'Obagi C20 維他命精華營養液',
          brandName: 'Dermacept',
          rank: 9,
        },
        {
          productId: 34290,
          productName: '煥白淨斑精華',
          brandName: 'XOVE',
          rank: 10,
        },
      ],
      oily: [
        {
          productId: 87,
          productName: '醫學維C淡斑精華',
          brandName: "Kiehl's",
          rank: 1,
        },
        {
          productId: 613,
          productName: 'EAA20亮白抗氧精華',
          brandName: 'factiv',
          rank: 2,
        },
        {
          productId: 26072,
          productName: 'PROX 亮潔晳顏淡斑精華 (新升級抗氧淡斑精華)',
          brandName: 'Olay',
          rank: 3,
        },
        {
          productId: 81,
          productName: 'Obagi C20 維他命精華營養液',
          brandName: 'Dermacept',
          rank: 4,
        },
        {
          productId: 562,
          productName: '葡萄蔓極緻亮白精華液',
          brandName: 'Caudalie',
          rank: 5,
        },
        {
          productId: 33399,
          productName: '維他命 C亮白精華',
          brandName: 'unlabel',
          rank: 6,
        },
        {
          productId: 34836,
          productName: '維他命C綠茶酵素透亮精華 (維C極光精華)',
          brandName: 'Innisfree',
          rank: 7,
        },
        {
          productId: 3185,
          productName: '透亮抗敏全效淨斑精華',
          brandName: 'Cetaphil',
          rank: 8,
        },
        {
          productId: 36562,
          productName: 'No.5 穀胱甘肽 C 瑕疵橡皮擦安瓶',
          brandName: 'Numbuzin',
          rank: 9,
        },
        {
          productId: 34290,
          productName: '煥白淨斑精華',
          brandName: 'XOVE',
          rank: 10,
        },
      ],
      combination: [
        {
          productId: 87,
          productName: '醫學維C淡斑精華',
          brandName: "Kiehl's",
          rank: 1,
        },
        {
          productId: 26072,
          productName: 'PROX 亮潔晳顏淡斑精華 (新升級抗氧淡斑精華)',
          brandName: 'Olay',
          rank: 2,
        },
        {
          productId: 562,
          productName: '葡萄蔓極緻亮白精華液',
          brandName: 'Caudalie',
          rank: 3,
        },
        {
          productId: 29975,
          productName: '肌源鑽光精華',
          brandName: 'SK-ll',
          rank: 4,
        },
        {
          productId: 33399,
          productName: '維他命 C亮白精華',
          brandName: 'unlabel',
          rank: 5,
        },
        {
          productId: 81,
          productName: 'Obagi C20 維他命精華營養液',
          brandName: 'Dermacept',
          rank: 6,
        },
        {
          productId: 79,
          productName: '升級版勻淨科研亮白淡斑雙效精華',
          brandName: 'Clinique',
          rank: 7,
        },
        {
          productId: 34836,
          productName: '維他命C綠茶酵素透亮精華 (維C極光精華)',
          brandName: 'Innisfree',
          rank: 8,
        },
        {
          productId: 28363,
          productName: 'MELANO CC 特濃純維C精華',
          brandName: '樂敦',
          rank: 9,
        },
        {
          productId: 25642,
          productName: 'Luminous630 雙效淡斑透白精華',
          brandName: 'Nivea',
          rank: 10,
        },
      ],
      sensitive: [
        {
          productId: 87,
          productName: '醫學維C淡斑精華',
          brandName: "Kiehl's",
          rank: 1,
        },
        {
          productId: 79,
          productName: '升級版勻淨科研亮白淡斑雙效精華',
          brandName: 'Clinique',
          rank: 2,
        },
        {
          productId: 29975,
          productName: '肌源鑽光精華',
          brandName: 'SK-ll',
          rank: 3,
        },
        {
          productId: 26072,
          productName: 'PROX 亮潔晳顏淡斑精華 (新升級抗氧淡斑精華)',
          brandName: 'Olay',
          rank: 4,
        },
        {
          productId: 34836,
          productName: '維他命C綠茶酵素透亮精華 (維C極光精華)',
          brandName: 'Innisfree',
          rank: 5,
        },
        {
          productId: 562,
          productName: '葡萄蔓極緻亮白精華液',
          brandName: 'Caudalie',
          rank: 6,
        },
        {
          productId: 33399,
          productName: '維他命 C亮白精華',
          brandName: 'unlabel',
          rank: 7,
        },
        {
          productId: 81,
          productName: 'Obagi C20 維他命精華營養液',
          brandName: 'Dermacept',
          rank: 8,
        },
        {
          productId: 28363,
          productName: 'MELANO CC 特濃純維C精華',
          brandName: '樂敦',
          rank: 9,
        },
        {
          productId: 3185,
          productName: '透亮抗敏全效淨斑精華',
          brandName: 'Cetaphil',
          rank: 10,
        },
      ],
    },
  },
  {
    name: '深層清潔/去角質',
    key: 'exfoliation',
    factor: {
      overall: [
        {
          productId: 1286,
          productName: '亞瑪遜白泥毛孔深層清潔面膜',
          brandName: "Kiehl's",
          rank: 1,
        },
        {
          productId: 623,
          productName: 'Soft Pads',
          brandName: 'Stridex',
          rank: 2,
        },
        {
          productId: 1290,
          productName: '薄荷清爽面膜',
          brandName: 'Lush',
          rank: 3,
        },
        {
          productId: 3201,
          productName: '一步清潔棉片',
          brandName: 'Cosrx',
          rank: 4,
        },
        {
          productId: 34895,
          productName: '黑頭粉刺導出液',
          brandName: 'Ilso',
          rank: 5,
        },
        {
          productId: 453,
          productName: '甘醇酸7%爽膚水',
          brandName: 'The Ordinary',
          rank: 6,
        },
        {
          productId: 1284,
          productName: '濟州島火山泥毛孔潔淨面膜',
          brandName: 'Innisfree',
          rank: 7,
        },
        {
          productId: 70,
          productName: '茶樹3合1潔淨磨砂面膜',
          brandName: 'The Body Shop',
          rank: 8,
        },
        {
          productId: 31205,
          productName: '玉容面膜',
          brandName: 'Sulwhasoo 雪花秀',
          rank: 9,
        },
        {
          productId: 3352,
          productName: '富士山溶岩深層淨肌泥膜',
          brandName: 'Pretti5',
          rank: 10,
        },
      ],
      neutral: [
        {
          productId: 1286,
          productName: '亞瑪遜白泥毛孔深層清潔面膜',
          brandName: "Kiehl's",
          rank: 1,
        },
        {
          productId: 623,
          productName: 'Soft Pads',
          brandName: 'Stridex',
          rank: 2,
        },
        {
          productId: 3201,
          productName: '一步清潔棉片',
          brandName: 'Cosrx',
          rank: 3,
        },
        {
          productId: 34895,
          productName: '黑頭粉刺導出液',
          brandName: 'Ilso',
          rank: 4,
        },
        {
          productId: 23494,
          productName: 'ZERO毛孔爽膚棉2.0',
          brandName: 'Medicube',
          rank: 5,
        },
        {
          productId: 31451,
          productName: '肌底代謝美容水',
          brandName: 'TAKAMI',
          rank: 6,
        },
        {
          productId: 35677,
          productName: '超A醇煥顏緊緻精華1.5%',
          brandName: 'DR.WU',
          rank: 7,
        },
        {
          productId: 1290,
          productName: '薄荷清爽面膜',
          brandName: 'Lush',
          rank: 8,
        },
        {
          productId: 453,
          productName: '甘醇酸7%爽膚水',
          brandName: 'The Ordinary',
          rank: 9,
        },
        {
          productId: 31205,
          productName: '玉容面膜',
          brandName: 'Sulwhasoo 雪花秀',
          rank: 10,
        },
      ],
      dry: [
        {
          productId: 1286,
          productName: '亞瑪遜白泥毛孔深層清潔面膜',
          brandName: "Kiehl's",
          rank: 1,
        },
        {
          productId: 623,
          productName: 'Soft Pads',
          brandName: 'Stridex',
          rank: 2,
        },
        {
          productId: 1284,
          productName: '濟州島火山泥毛孔潔淨面膜',
          brandName: 'Innisfree',
          rank: 3,
        },
        {
          productId: 1290,
          productName: '薄荷清爽面膜',
          brandName: 'Lush',
          rank: 4,
        },
        {
          productId: 34895,
          productName: '黑頭粉刺導出液',
          brandName: 'Ilso',
          rank: 5,
        },
        {
          productId: 3201,
          productName: '一步清潔棉片',
          brandName: 'Cosrx',
          rank: 6,
        },
        {
          productId: 453,
          productName: '甘醇酸7%爽膚水',
          brandName: 'The Ordinary',
          rank: 7,
        },
        {
          productId: 31205,
          productName: '玉容面膜',
          brandName: 'Sulwhasoo 雪花秀',
          rank: 8,
        },
        {
          productId: 1311,
          productName: '全能急救面膜',
          brandName: 'Eve Lom',
          rank: 9,
        },
        {
          productId: 70,
          productName: '茶樹3合1潔淨磨砂面膜',
          brandName: 'The Body Shop',
          rank: 10,
        },
      ],
      oily: [
        {
          productId: 1286,
          productName: '亞瑪遜白泥毛孔深層清潔面膜',
          brandName: "Kiehl's",
          rank: 1,
        },
        {
          productId: 623,
          productName: 'Soft Pads',
          brandName: 'Stridex',
          rank: 2,
        },
        {
          productId: 34895,
          productName: '黑頭粉刺導出液',
          brandName: 'Ilso',
          rank: 3,
        },
        {
          productId: 1284,
          productName: '濟州島火山泥毛孔潔淨面膜',
          brandName: 'Innisfree',
          rank: 4,
        },
        {
          productId: 1281,
          productName: '意大利白泥淨化排毒面膜',
          brandName: 'Fresh',
          rank: 5,
        },
        {
          productId: 1290,
          productName: '薄荷清爽面膜',
          brandName: 'Lush',
          rank: 6,
        },
        {
          productId: 453,
          productName: '甘醇酸7%爽膚水',
          brandName: 'The Ordinary',
          rank: 7,
        },
        {
          productId: 3201,
          productName: '一步清潔棉片',
          brandName: 'Cosrx',
          rank: 8,
        },
        {
          productId: 1314,
          productName: '粉紅淨化膜',
          brandName: 'Solskin',
          rank: 9,
        },
        {
          productId: 1299,
          productName: '死海鑽奇三合一磨砂面膜',
          brandName: 'Sabon',
          rank: 10,
        },
      ],
      combination: [
        {
          productId: 1286,
          productName: '亞瑪遜白泥毛孔深層清潔面膜',
          brandName: "Kiehl's",
          rank: 1,
        },
        {
          productId: 623,
          productName: 'Soft Pads',
          brandName: 'Stridex',
          rank: 2,
        },
        {
          productId: 1290,
          productName: '薄荷清爽面膜',
          brandName: 'Lush',
          rank: 3,
        },
        {
          productId: 3201,
          productName: '一步清潔棉片',
          brandName: 'Cosrx',
          rank: 4,
        },
        {
          productId: 34895,
          productName: '黑頭粉刺導出液',
          brandName: 'Ilso',
          rank: 5,
        },
        {
          productId: 453,
          productName: '甘醇酸7%爽膚水',
          brandName: 'The Ordinary',
          rank: 6,
        },
        {
          productId: 70,
          productName: '茶樹3合1潔淨磨砂面膜',
          brandName: 'The Body Shop',
          rank: 7,
        },
        {
          productId: 1284,
          productName: '濟州島火山泥毛孔潔淨面膜',
          brandName: 'Innisfree',
          rank: 8,
        },
        {
          productId: 31205,
          productName: '玉容面膜',
          brandName: 'Sulwhasoo 雪花秀',
          rank: 9,
        },
        {
          productId: 23494,
          productName: 'ZERO毛孔爽膚棉2.0',
          brandName: 'Medicube',
          rank: 10,
        },
      ],
      sensitive: [
        {
          productId: 1286,
          productName: '亞瑪遜白泥毛孔深層清潔面膜',
          brandName: "Kiehl's",
          rank: 1,
        },
        {
          productId: 623,
          productName: 'Soft Pads',
          brandName: 'Stridex',
          rank: 2,
        },
        {
          productId: 3201,
          productName: '一步清潔棉片',
          brandName: 'Cosrx',
          rank: 3,
        },
        {
          productId: 34895,
          productName: '黑頭粉刺導出液',
          brandName: 'Ilso',
          rank: 4,
        },
        {
          productId: 1290,
          productName: '薄荷清爽面膜',
          brandName: 'Lush',
          rank: 5,
        },
        {
          productId: 453,
          productName: '甘醇酸7%爽膚水',
          brandName: 'The Ordinary',
          rank: 6,
        },
        {
          productId: 31205,
          productName: '玉容面膜',
          brandName: 'Sulwhasoo 雪花秀',
          rank: 7,
        },
        {
          productId: 70,
          productName: '茶樹3合1潔淨磨砂面膜',
          brandName: 'The Body Shop',
          rank: 8,
        },
        {
          productId: 1314,
          productName: '粉紅淨化膜',
          brandName: 'Solskin',
          rank: 9,
        },
        {
          productId: 1299,
          productName: '死海鑽奇三合一磨砂面膜',
          brandName: 'Sabon',
          rank: 10,
        },
      ],
    },
  },
  {
    name: '濕疹護理',
    key: 'eczema',
    factor: {
      overall: [
        {
          productId: 8645,
          productName: '舒特膚潤膚膏',
          brandName: 'Cetaphil',
          rank: 1,
        },
        {
          productId: 615,
          productName: 'B5萬用修復霜',
          brandName: 'La Roche-Posay',
          rank: 2,
        },
        {
          productId: 2857,
          productName: '濕疹舒緩潤膚膏',
          brandName: 'Aveeno',
          rank: 3,
        },
        {
          productId: 220,
          productName: '潔美淨抗敏紓緩乳霜',
          brandName: 'Physiogel',
          rank: 4,
        },
        {
          productId: 6694,
          productName: '強效滋潤修護霜 Atoderm Intensive Baume',
          brandName: 'Bioderma',
          rank: 5,
        },
        {
          productId: 608,
          productName: 'AD軟膏',
          brandName: '曼秀雷敦 Mentholatum',
          rank: 6,
        },
        {
          productId: 165,
          productName: '長效滋潤修復霜',
          brandName: 'CeraVe',
          rank: 7,
        },
        {
          productId: 3,
          productName: '澳洲羊奶皂',
          brandName: '澳洲羊奶皂',
          rank: 8,
        },
        {
          productId: 2888,
          productName: '專業舒敏修護燕麥保濕乳',
          brandName: 'Vaseline 凡士林',
          rank: 9,
        },
        {
          productId: 1148,
          productName: '娥羅納英H軟膏',
          brandName: 'Oronine 娥羅納英',
          rank: 10,
        },
      ],
      neutral: [
        {
          productId: 220,
          productName: '潔美淨抗敏紓緩乳霜',
          brandName: 'Physiogel',
          rank: 1,
        },
        {
          productId: 2857,
          productName: '濕疹舒緩潤膚膏',
          brandName: 'Aveeno',
          rank: 2,
        },
        {
          productId: 615,
          productName: 'B5萬用修復霜',
          brandName: 'La Roche-Posay',
          rank: 3,
        },
        {
          productId: 3,
          productName: '澳洲羊奶皂',
          brandName: '澳洲羊奶皂',
          rank: 4,
        },
        {
          productId: 8645,
          productName: '舒特膚潤膚膏',
          brandName: 'Cetaphil',
          rank: 5,
        },
        {
          productId: 6694,
          productName: '強效滋潤修護霜 Atoderm Intensive Baume',
          brandName: 'Bioderma',
          rank: 6,
        },
        {
          productId: 608,
          productName: 'AD軟膏',
          brandName: '曼秀雷敦 Mentholatum',
          rank: 7,
        },
        {
          productId: 165,
          productName: '長效滋潤修復霜',
          brandName: 'CeraVe',
          rank: 8,
        },
        {
          productId: 8644,
          productName: '舒特膚潤膚乳液',
          brandName: 'Cetaphil',
          rank: 9,
        },
        {
          productId: 1148,
          productName: '娥羅納英H軟膏',
          brandName: 'Oronine 娥羅納英',
          rank: 10,
        },
      ],
      dry: [
        {
          productId: 2857,
          productName: '濕疹舒緩潤膚膏',
          brandName: 'Aveeno',
          rank: 1,
        },
        {
          productId: 615,
          productName: 'B5萬用修復霜',
          brandName: 'La Roche-Posay',
          rank: 2,
        },
        {
          productId: 8645,
          productName: '舒特膚潤膚膏',
          brandName: 'Cetaphil',
          rank: 3,
        },
        {
          productId: 6694,
          productName: '強效滋潤修護霜 Atoderm Intensive Baume',
          brandName: 'Bioderma',
          rank: 4,
        },
        {
          productId: 165,
          productName: '長效滋潤修復霜',
          brandName: 'CeraVe',
          rank: 5,
        },
        {
          productId: 2888,
          productName: '專業舒敏修護燕麥保濕乳',
          brandName: 'Vaseline 凡士林',
          rank: 6,
        },
        {
          productId: 220,
          productName: '潔美淨抗敏紓緩乳霜',
          brandName: 'Physiogel',
          rank: 7,
        },
        {
          productId: 212,
          productName: '常春藤修復鎮靜面霜',
          brandName: 'Milktouch',
          rank: 8,
        },
        {
          productId: 8644,
          productName: '舒特膚潤膚乳液',
          brandName: 'Cetaphil',
          rank: 9,
        },
        {
          productId: 608,
          productName: 'AD軟膏',
          brandName: '曼秀雷敦 Mentholatum',
          rank: 10,
        },
      ],
      oily: [
        {
          productId: 615,
          productName: 'B5萬用修復霜',
          brandName: 'La Roche-Posay',
          rank: 1,
        },
        {
          productId: 2857,
          productName: '濕疹舒緩潤膚膏',
          brandName: 'Aveeno',
          rank: 2,
        },
        {
          productId: 220,
          productName: '潔美淨抗敏紓緩乳霜',
          brandName: 'Physiogel',
          rank: 3,
        },
        {
          productId: 8645,
          productName: '舒特膚潤膚膏',
          brandName: 'Cetaphil',
          rank: 4,
        },
        {
          productId: 6694,
          productName: '強效滋潤修護霜 Atoderm Intensive Baume',
          brandName: 'Bioderma',
          rank: 5,
        },
        {
          productId: 2888,
          productName: '專業舒敏修護燕麥保濕乳',
          brandName: 'Vaseline 凡士林',
          rank: 6,
        },
        {
          productId: 3,
          productName: '澳洲羊奶皂',
          brandName: '澳洲羊奶皂',
          rank: 7,
        },
        {
          productId: 165,
          productName: '長效滋潤修復霜',
          brandName: 'CeraVe',
          rank: 8,
        },
        {
          productId: 608,
          productName: 'AD軟膏',
          brandName: '曼秀雷敦 Mentholatum',
          rank: 9,
        },
        {
          productId: 1041,
          productName: '天然燕麥高效舒緩沐浴露',
          brandName: 'Aveeno',
          rank: 10,
        },
      ],
      combination: [
        {
          productId: 8645,
          productName: '舒特膚潤膚膏',
          brandName: 'Cetaphil',
          rank: 1,
        },
        {
          productId: 615,
          productName: 'B5萬用修復霜',
          brandName: 'La Roche-Posay',
          rank: 2,
        },
        {
          productId: 2857,
          productName: '濕疹舒緩潤膚膏',
          brandName: 'Aveeno',
          rank: 3,
        },
        {
          productId: 220,
          productName: '潔美淨抗敏紓緩乳霜',
          brandName: 'Physiogel',
          rank: 4,
        },
        {
          productId: 6694,
          productName: '強效滋潤修護霜 Atoderm Intensive Baume',
          brandName: 'Bioderma',
          rank: 5,
        },
        {
          productId: 608,
          productName: 'AD軟膏',
          brandName: '曼秀雷敦 Mentholatum',
          rank: 6,
        },
        {
          productId: 165,
          productName: '長效滋潤修復霜',
          brandName: 'CeraVe',
          rank: 7,
        },
        {
          productId: 3,
          productName: '澳洲羊奶皂',
          brandName: '澳洲羊奶皂',
          rank: 8,
        },
        {
          productId: 2888,
          productName: '專業舒敏修護燕麥保濕乳',
          brandName: 'Vaseline 凡士林',
          rank: 9,
        },
        {
          productId: 1148,
          productName: '娥羅納英H軟膏',
          brandName: 'Oronine 娥羅納英',
          rank: 10,
        },
      ],
      sensitive: [
        {
          productId: 8645,
          productName: '舒特膚潤膚膏',
          brandName: 'Cetaphil',
          rank: 1,
        },
        {
          productId: 220,
          productName: '潔美淨抗敏紓緩乳霜',
          brandName: 'Physiogel',
          rank: 2,
        },
        {
          productId: 615,
          productName: 'B5萬用修復霜',
          brandName: 'La Roche-Posay',
          rank: 3,
        },
        {
          productId: 2857,
          productName: '濕疹舒緩潤膚膏',
          brandName: 'Aveeno',
          rank: 4,
        },
        {
          productId: 165,
          productName: '長效滋潤修復霜',
          brandName: 'CeraVe',
          rank: 5,
        },
        {
          productId: 205,
          productName: '精華面霜',
          brandName: 'La Mer',
          rank: 6,
        },
        {
          productId: 6694,
          productName: '強效滋潤修護霜 Atoderm Intensive Baume',
          brandName: 'Bioderma',
          rank: 7,
        },
        {
          productId: 1148,
          productName: '娥羅納英H軟膏',
          brandName: 'Oronine 娥羅納英',
          rank: 8,
        },
        {
          productId: 608,
          productName: 'AD軟膏',
          brandName: '曼秀雷敦 Mentholatum',
          rank: 9,
        },
        {
          productId: 2888,
          productName: '專業舒敏修護燕麥保濕乳',
          brandName: 'Vaseline 凡士林',
          rank: 10,
        },
      ],
    },
  },
];

export const getProductOverallRanks = (productId) => {
  const result = [];
  if (_.isNil(productId)) {
    return result;
  }
  for (var i = 0; i < ranks.length; i++) {
    const { key, name, factor } = ranks[i];
    const { overall } = factor;
    const rank = _.find(overall, { productId });
    if (rank) {
      result.push({
        key,
        name,
        rank: rank.rank,
      });
    }
  }
  return _.orderBy(result, ['rank'], ['asc']);
};
